import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";


function Customs() {
    return (
        <>        
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Customs, Vat and
Duty Management</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>You can contact us for various customs formalities with regard to export, import, storage and transit shipments. We are also happy to help you with veterinary inspections. Or we advise you on specific customs or tax issues. Unburdening, that's what we stand for. Both import and export require customs formalities with many different types of documents. These documents may also differ per country and product. Our customs declarants are specialized in these regulations and organize the necessary documents for your shipment. In this way, the import, export and transit of your loads takes place quickly and effectively.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
           
        </>
    )
}

export default Customs